/**
 * Normalize a note's `tags` into a string array (tolerant of nulls/garbage).
 *
 * The notes API sends a JSON array; older code assumed a JSON-encoded string and
 * ran `JSON.parse` on the array, which threw — so tags never rendered. Both
 * shapes are accepted. Mirrors mobile/src/features/notes/tags.ts.
 */
export function parseTags(tags: readonly string[] | string | null | undefined): string[] {
  if (!tags) return [];
  if (Array.isArray(tags)) return tags.map(String);
  try {
    const parsed: unknown = JSON.parse(tags as string);
    return Array.isArray(parsed) ? parsed.map(String) : [];
  } catch {
    return [];
  }
}
